"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.ButtonDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.ButtonDefaultProps = {
  type: 'button',
  size: 'normal',
  color: 'primary',
  borderRadius: 6,
  disabled: false,
  textColor: 'dark',
  onClick: function () {}
};
// -------- Styles -------->
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    white-space: nowrap;\n    background: none;\n    justify-content: center;\n    align-items: center;\n    outline: none;\n    border: none;\n    width: 100%;\n    padding: ", " ", ";\n    text-decoration: none;\n    font-size: ", ";\n    font-weight: 500;\n    font-family: ", ";\n    cursor: pointer;\n\n    &:focus {\n      box-shadow: 0px 0px 0px 2px ", ";\n    }\n\n    ", "\n\n    ", ";\n\n\n    /* --- Sizes --- */\n    ", "\n\n  "], ["\n    display: flex;\n    white-space: nowrap;\n    background: none;\n    justify-content: center;\n    align-items: center;\n    outline: none;\n    border: none;\n    width: 100%;\n    padding: ", " ", ";\n    text-decoration: none;\n    font-size: ", ";\n    font-weight: 500;\n    font-family: ", ";\n    cursor: pointer;\n\n    &:focus {\n      box-shadow: 0px 0px 0px 2px ", ";\n    }\n\n    ", "\n\n    ", ";\n\n\n    /* --- Sizes --- */\n    ", "\n\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.FONT_SIZE(14), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('primary'), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", "}\n      border-radius: ", "px;\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    "], ["\n      color: ", "}\n      border-radius: ", "px;\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    "])), theme_1.theme.COLOR(props.textColor), props.borderRadius, theme_1.theme.COLOR(props.color), theme_1.theme.HOVER_COLOR(props.color));
  }, function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: default;\n      opacity: 0.5;\n      &:hover {\n        background-color: ", ";\n      }\n    "], ["\n      cursor: default;\n      opacity: 0.5;\n      &:hover {\n        background-color: ", ";\n      }\n    "])), theme_1.theme.COLOR(props.color));
  }, function (props) {
    return props.size === 'large' && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: 24px;\n      padding: ", " ", ";\n    "], ["\n      font-size: 24px;\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(6));
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: auto;\n\n    ", "\n  "], ["\n    width: auto;\n\n    ", "\n  "])), function (props) {
    return props.size === 'fluid' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Button: styled_components_1.default.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
var Button = function (props) {
  var children = props.children,
    rest = __rest(props, ["children"]);
  return React.createElement(My.Button, __assign({}, rest), children);
};
exports.Button = Button;
exports.Button.defaultProps = exports.ButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;